import * as React from "react";
import Modal from "./Modal";
import ModalHeader from "./ModalHeader";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";
import Button from "./Button";
import useConfig from "../hooks/useConfig";
import StoreContainer from "../stores/StoreContainer";

export default function CobrowseConsentModal() {
  const [showModal, setShowModal] = React.useState(false);
  const [sessionId, setSessionId] = React.useState("");
  const [rootUrl, setRootUrl] = React.useState("");
  const config = useConfig();

  React.useEffect(() => {
    function handler(message: any) {
      setSessionId(message.SessionId);
      setRootUrl(message.RootUrl);
      setShowModal(true);
    }

    StoreContainer.ChatStore.onReceiveCobrowseRequest(handler);

    return () => {
      StoreContainer.ChatStore.offReceiveCobrowseRequest(handler);
    };
  }, []);

  if (!showModal) {
    return null;
  }

  return (
    <Modal>
      <ModalHeader>Co-Browse Request</ModalHeader>
      <ModalBody>Would you like to share you screen?</ModalBody>
      <ModalFooter>
        <Button
          variant="primary"
          autoFocus
          onClick={() => {
            StoreContainer.CobrowseStore.acceptRequest(rootUrl, sessionId);
            setShowModal(false);
          }}
        >
          {config.YesButtonText}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            StoreContainer.CobrowseStore.declineRequest();
            setShowModal(false);
          }}
        >
          {config.NoButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
